import { SmartphoneIconFilled } from '@karma/components/icons';
import { Stack, Typography } from '@karma/components';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { useContext } from 'react';
import { WEBSITE_PATH } from '@karma/utils/constants/env';
import { useSelector } from 'react-redux';
import KarmaEarnPlatforms from 'components/molecules/KarmaEarnPlatforms/KarmaEarnPlatforms';
import { PATHS } from 'consts/paths';
import Alooma from 'services/alooma';
import { DEVICE_TYPES } from 'consts/karmaEarn';
import { getUserId } from 'store/user/selectors';
import { Content } from './ModalBodyKarmaEarnPlayMobileDevices.style';

const ModalBodyKarmaEarnPlayMobileDevices = ({ item }) => {
  const { t } = useTranslation();
  const aloomaSource = useContext(Alooma.SourceContext);
  const userId = useSelector(getUserId);
  const iosDevice = item.devices.filter(({ device }) => device === DEVICE_TYPES.IOS);
  const androidDevice = item.devices.filter(({ device }) => device === DEVICE_TYPES.ANDROID);

  return (
    <Content>
      <SmartphoneIconFilled width={40} height={40} />
      <Typography variant="labelLarge" align="center" tMargin={20} bMargin={8}>
        {t('app:useYourMobileDevice')}
      </Typography>
      <Typography variant="paragraphMedium" bMargin={20}>
        {t('app:scanQrCode')}
      </Typography>
      <QRCode
        value={`${WEBSITE_PATH}${PATHS.REDIRECT}?karma_earn_id=${item.id}&shop=${encodeURIComponent(
          item.title,
        )}&alooma_source=${aloomaSource}&user_id=${userId}`}
        size={240}
      />
      <Stack tMargin={20} spacing={4}>
        {!!iosDevice?.length && <KarmaEarnPlatforms devices={iosDevice} />}
        {!!androidDevice?.length && <KarmaEarnPlatforms devices={androidDevice} />}
      </Stack>
    </Content>
  );
};

export default ModalBodyKarmaEarnPlayMobileDevices;
